<div class="route-component">
    <div class="search-component">
        <h4>
            Policy Groups
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['PolicyGroup', 'Create']" (click)="addPolicyGroup()">
                        Add <i class="fas fa-plus"></i>
                    </button>
                    <button *hasPermission="['PolicyGroup', 'Export']" (click)="downloadPolicyGroups(paging)">
                        Download <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="refreshGridData()">
                    <button class="search-button" (click)="refreshGridData()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="policyGroups"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getPolicyGroups($event)"
            [showEdit]="showEdit || false"
            (editItem)="editPolicyGroup($event)"
            [showDelete]="showDelete || false"
            (deleteItem)="deletePolicyGroup($event)">
        </pageable-table>
    </div>
</div>